// extracted by mini-css-extract-plugin
module.exports = {"myProfileJoinCompanyContainer":"styles_myProfileJoinCompanyContainer__3JUoN","myProfileJoinCompanyContent":"styles_myProfileJoinCompanyContent__2qdiR"};